<template>
  <div class="text-h6">パディング</div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>オール</div>
      <div class="text-caption">paddingAll</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.paddingAll"
      :rules="[
        (val) => paddingValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in paddingList"
              clickable
              v-close-popup
              :key="index"
              @click="value.paddingAll = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>トップ</div>
      <div class="text-caption">paddingTop</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.paddingTop"
      :rules="[
        (val) => paddingValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in paddingList"
              clickable
              v-close-popup
              :key="index"
              @click="value.paddingTop = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>ボトム</div>
      <div class="text-caption">paddingBottom</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.paddingBottom"
      :rules="[
        (val) => paddingValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in paddingList"
              clickable
              v-close-popup
              :key="index"
              @click="value.paddingBottom = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>スタート</div>
      <div class="text-caption">paddingStart</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.paddingStart"
      :rules="[
        (val) => paddingValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in paddingList"
              clickable
              v-close-popup
              :key="index"
              @click="value.paddingStart = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>エンド</div>
      <div class="text-caption">paddingEnd</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.paddingEnd"
      :rules="[
        (val) => paddingValidate(val) || 'invalid property',
      ]"
      placeholder="XXpx"
      class="col flex-input"
    >
      <template v-slot:append>
        <q-btn-dropdown
          no-caps
          unelevated
          color="brand-grey"
          label="px, % or keywords"
        >
          <q-list>
            <q-item
              v-for="(item, index) in paddingList"
              clickable
              v-close-popup
              :key="index"
              @click="value.paddingEnd = item"
            >
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-input>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBox } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Padding extends Vue {
  @Prop()
  modelValue!: IFlexMessageBox

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBox) {
    this.$emit('update:modelValue', value)
  }

  get paddingList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  paddingValidate(val) {
    if (!val) return true

    const isPxOrPercent = /^(\d+(\.\d+)?)(px|%)$/.test(val)
    const isKeyword = this.paddingList.includes(val)
    return !(!isPxOrPercent && !isKeyword)
  }
}
</script>

<style scoped lang="scss">

</style>
